import dayjs from 'dayjs';
import _ from 'lodash';

import { ACTIVITIES } from '../constant/index';

export const processMindgymActivity = (data) => {
    const activity = ACTIVITIES[data.type];

    if (!activity) return {};

    let date = '';
    let detail = '';

    const dateFormat = 'DD MMM YYYY';

    date = `${dayjs(data?.startDate).format(dateFormat)} - ${dayjs(data?.endDate).format(
        dateFormat
    )}`;

    switch (data?.type) {
        case 'MOOD_TRACKER':
        case 'COMMUNICATION_JOURNAL':
            detail = `${data?.frequency} times/day`;
            break;
        case 'BEHAVIORAL_TRACKER':
            detail = `${data?.workout?.length} items`;
            break;
        case 'BREATHING_EXERCISE':
            detail = `${data?.workout}, ${data?.duration} mins, ${data?.frequency} times/day`;
            break;
        case 'PROGRESSIVE_MUSCLE_RELAXATION':
            detail = `${data?.duration} mins, ${data?.frequency} times/day`;
            break;
        case 'MINDFULNESS':
            detail = `${data?.workout}, ${data?.duration} mins, ${data?.frequency} times/day`;
            break;
        default:
            break;
    }

    return { title: activity?.title, icon: activity?.icon, date, detail, status: data?.status };
};

export const processMindgymReport = (data) => {
    const newReport = [];

    if (_.isEmpty(data)) return newReport;

    for (const activity in ACTIVITIES) {
        const { payloadType, title, icon } = ACTIVITIES[activity];

        const filterActivity = data.filter((item) =>
            Object.prototype.hasOwnProperty.call(item, payloadType)
        );

        filterActivity.forEach((item) => {
            const { settings, frequencyPerDay, status } = item[payloadType];

            const obj = {
                type: activity,
                title,
                icon,
                frequency: frequencyPerDay,
                startDate: settings?.startDate,
                endDate: settings?.endDate,
                status,
            };

            if (activity === 'BEHAVIORAL_TRACKER') {
                obj.workout = !_.isEmpty(settings?.goals) ? settings?.goals : [];
            }

            if (['BREATHING_EXERCISE', 'MINDFULNESS'].includes(activity)) {
                obj.workout = settings?.workoutOption?.category;
            }

            if (['BREATHING_EXERCISE', 'PROGRESSIVE_MUSCLE_RELAXATION', 'MINDFULNESS'].includes(activity)) {
                obj.duration = millisecondsToMinutes(settings?.workoutOption?.duration);
            }

            newReport.push(obj);
        });
    }

    return newReport;
};

export const minutesToMilliseconds = (minutes) => {
    if (!minutes) return 0;
    return minutes * 60000;
};

export const millisecondsToMinutes = (milliseconds) => {
    if (!milliseconds) return 0;
    return Math.trunc(milliseconds / 60000);
};
